import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { SellerView } from "@/lib/api/types";
import { endpoints } from "@/lib/api/endpoints";
import { apiJsonClient } from "@/lib/query/core/api-json-client";
import { invalidateSellerSession } from "@/lib/query/core/invalidation";

type UpdateSellerProfileInput = {
  storeSlug: string;
  name: string;
  email: string;
  phone: string;
};

export function useUpdateProfileMutation() {
  const queryClient = useQueryClient();
  const mutation = useMutation({
    mutationFn: (input: UpdateSellerProfileInput) => {
      const { storeSlug, ...body } = input;
      void storeSlug;
      return apiJsonClient<{ seller?: SellerView }>(endpoints.seller.profile, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
      });
    },
    onSuccess: async (_data, variables) => {
      await invalidateSellerSession(queryClient, variables.storeSlug);
    },
  });

  return {
    mutateAsync: mutation.mutateAsync,
    isPending: mutation.isPending,
    error: mutation.error,
    reset: mutation.reset,
  };
}
